import { createTheme } from '@mui/material/styles';
import { C, F } from './tokens';

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; outline: none; }
        body {
          font-family: ${F.body};
          background-color: ${C.bg};
          color: ${C.text};
          line-height: 1.65;
          min-height: 100vh;
        }
        ul { list-style: none; padding: 0; }
        a { text-decoration: none; color: ${C.primary}; transition: color 0.25s ease; }
        a:hover { color: ${C.accent}; }
        h1, h2, h3, h4 { font-weight: 600; line-height: 1.25; }
        img { display: block; max-width: 100%; }
        em { font-style: italic; }
      `,
    },
  },
});

export default theme;
